import Core              from '@/core/Core';
import TehnoShipment     from '@/domains/Shipments/TehnoShipment';
import TehnoShipmentsDAO from '@/domains/Shipments/TehnoShipmentsDAO';

class TehnoShipmentsService {
  /** null — отгрузка ещё не выгружалась в Техно */
  static async getByShipmentId(shipmentId: number): Promise<TehnoShipment | null> {
    const response = await TehnoShipmentsDAO.get(shipmentId);

    return Core.utils.hydrate(response.data, TehnoShipment.fromServer);
  }

  static showTehnoShipmentCard(shipmentId: number): Promise<boolean> {
    return Core.dialogs.TehnoShipmentCard.showAsPromise({ shipmentId });
  }
}

export default TehnoShipmentsService;
